module.exports = __webpack_public_path__ + "static/media/aff.20b3ce06.png";